/* istanbul ignore file */
import styled, { css } from 'styled-components';

import { media } from 'app/shared/styles_js/variables';
import {
  AccordionItemSt,
  TitleSt,
  ContentSt,
} from 'app/marketplace/contentful/shared/ContentfulAccordionItem/ContentfulAccordionItem.css';
import { MarkdownContainerSt } from 'app/marketplace/contentful/shared/MarkdownContainer/MarkdownContainer.css';
import { WrapperSt } from 'app/marketplace/contentful/shared/CallToActionBlockV2/CallToActionBlockV2.css';
import { MarkdownContainerSt as LegalTextMarkdownContainerSt } from 'app/marketplace/contentful/shared/LegalText/LegalText.css';

export const InsuranceHubWrapperSt = styled.div`
  ${MarkdownContainerSt} {
    p {
      padding-top: 10px;
    }
    ${media.sm(css`
      margin: 0;
      width: 100%;
      text-align: left;
    `)}
  }

  .markdown-container {
    ${media.sm(css`
      width: 87%;
    `)}
    ${media.md(css`
      width: 58%;
    `)}
    margin: 32px auto;
    text-align: center;
    font-size: 16px;
    line-height: 2;
  }

  ${LegalTextMarkdownContainerSt} {
    margin: 0;
    text-align: left;
  }

  ${AccordionItemSt} {
    width: auto;
    max-width: 768px;
    text-align: center;
    margin: 0 auto;

    &:last-child {
      margin-bottom: 128px;
    }
    ${media.sm(css`
      width: auto;
      max-width: 768px;
      margin: 0px 24px;
      text-align: left;
    `)}

    ${media.md(css`
      text-align: center;
      margin: 0 auto;
    `)}
    ${media.lg(css`
      margin: 0 auto;
    `)}




    ${ContentSt} {
      ${media.sm(css`
        .markdown-container {
          margin: 0px;
          width: 100%;
          text-align: left;
          display: block;

          p {
            font-size: 14px;
            font-weight: 200;
            line-height: 1.71;
          }
        }
      `)}
    }

    ${TitleSt} {
      ${media.sm(css`
        max-width: calc(100% - 14px);
      `)}
    }
  }

  ${WrapperSt} {
    margin: 4rem auto;
    padding: 0px;
  }
`;
